<template>
  <Card>
    <p slot="title">
      <Icon type="md-alert" />
      仓库库存盘点
    </p>
    <Form ref="formInline" :model="formInline" :rules="ruleInline" inline>
      <div style="display: flex; justify-content: center">
        <FormItem prop="wmsCode">
          <Select
            v-model="formInline.wmsCode"
            placeholder="请输入仓库名称"
            filterable
            clearable
            @on-select="handleCreate2"
            class="public-inp"
          >
            <Option
              v-for="(option, i) in wmsCodeList"
              :value="option.wmsCode"
              :key="i"
              >{{ option.wmsName }}</Option
            >
          </Select>
        </FormItem>
        <FormItem>
          <Button type="primary" @click="handleSubmit('formInline')"
            >确定</Button
          >
        </FormItem>
      </div>
    </Form>
  </Card>
</template>
<script>
export default {
  data() {
    return {
      wmsCodeList: [],
      wmsCodeLoading: false,
      formInline: {
        wmsCode: "",
      },
      ruleInline: {
        wmsCode: [{ required: true, message: "请选择仓库" }],
      },
      query: {},
    };
  },
  created() {
    this.getWmsList();
  },
  methods: {
    getWmsList() {
      this.$api.wareVagueSearch({ name: "" }).then((res) => {
        if (res.code == "200") {
          this.wmsCodeList = res.data;
        }
      });
    },
    handleCreate2(code) {
      this.wmsCodeList.forEach((item) => {
        if (item.wmsCode == code) {
          this.query = item;
        }
      });
    },
    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          let query = this.query;
          let path = "/inventoryEdit";
          this.$router.replace({ path, query });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/views/warehouse/inventory.vue